<template>
  <div class="product-characteristics">
    <div v-for="(product, i) in characteristics" :key="i">
      <div v-for="(characteristic, title, i) in product" :key="i">
        <ProductTable v-if="characteristic.length" :title="characteristics.length > 1 ? title : ''" :items="(description && characteristics.length > 3) ? characteristic.slice(0, 4) : description ? characteristic.slice(0, 7) : characteristic" />
      </div>
    </div>
  </div>
</template>

<script>
import ProductTable from './ProductTable'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ProductCharacteristics',
  components: {
    ProductTable
  },
  props: {
    description: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      characteristics: state => state.productInfo.productInfo.characteristics,
      initialOffset: state => state.productTabs.initialOffset
    })
  },
  methods: {
    ...mapActions(['SET_ACTIVE_TAB']),
    setActiveTab () {
      const data = {
        string: 'characteristics',
        top: this.initialOffset - 50
      }
      this.SET_ACTIVE_TAB(data)
    }
  }
}
</script>

<style scoped lang="sass">
.fake-link
  color: #3e77aa
  font-size: 14px
  border-bottom: 1px dashed #3e77aa
  cursor: pointer
  margin-top: 20px
  display: inline-block

</style>
